import { hasRoleAccessToRoute } from "@/shared/utils/role.utils";
import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";

export default async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  if (to.matched.some((record) => record.meta.skipMerchantGuards)) {
    next();
    return;
  }

  if (hasRoleAccessToRoute(to.name as string, to.params, to.query)) {
    next();
  } else {
    next({ name: "dashboard" });
  }
};
